import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = ({ label = "Back to top", targetRef, threshold = 700, testid = "back-to-top" }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  const go = () => {
    const el = targetRef?.current;
    if (el) { const hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-h")) || 64; window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - hh - 8), behavior: "smooth" }); }
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button type="button" onClick={go} aria-label={label} data-testid={testid}
      className={`fixed bottom-5 right-5 sm:bottom-8 sm:right-8 z-40 inline-flex items-center gap-2 h-11 pl-3.5 pr-4 rounded-full bg-[#ff6a13] text-white font-semibold text-sm shadow-[0_8px_30px_rgba(255,106,19,0.45)] hover:bg-[#ff8a3d] transition-[opacity,transform,background-color] duration-300 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
      <ArrowUp size={16} /><span className="hidden sm:inline">{label}</span>
    </button>
  );
};
